import Auth from './auth';


const stores = {
    auth: Auth,
};


export default stores;